import { render, staticRenderFns } from "./ThirdPartyRegisterModalTerm.vue?vue&type=template&id=251ef254&"
import script from "./ThirdPartyRegisterModalTerm.vue?vue&type=script&lang=js&"
export * from "./ThirdPartyRegisterModalTerm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* chakra-loader */
const installChakraComponents = require("!../../../../node_modules/chakra-loader/lib/install-components.js")
installChakraComponents(component, {CListItem: require('@chakra-ui/vue').CListItem, CList: require('@chakra-ui/vue').CList})
